module.exports = __webpack_public_path__ + "img/pt.pt6a02123.svg";